export class APGCovid19Constants {
    static bioradLimsMechine: string = 'BioradLims';
    static flaABIMechine: string ='FLA-ABI';
    static splitCondition : string = "1*384 to 4*96";
    static LC480SubType: string ='LC 480 II';
    static fastFinder: string = 'Fast Finder';
    static positiveControlBarcode ='POS_EX';
    static samplePositiveResult ='positive';
    static bioradManufacturer = 'Bio-Rad';
    static archiveBatchesPerPlate:number = 9;
    static quantStudio5: string = "QuantStudio5";
    static ABI7500: string = "ABI7500";
    static ariaUKFileType ='AriaDX-xls';
}

export class APGCovid19PoolConstants {
    static sequenceName: string = 'POOL_ID_BB_EBE';
    static prefix: string = 'PID';
    static digits: number = 8
}
